import React, { useEffect, useState } from 'react';
import { useQuery, gql } from '@apollo/client';
import RegistrarEmpleado from './RegistrarEmpleado';
import ImportarPersonal from './ImportarPersonal';
import EnviarComunicado from './EnviarComunicado';
import ConfigSMTP from './ConfigSMTP';
import ReportesPersonal from './ReportesPersonal'; // Nuevo Import
import { GestureNav } from './GestureNav';

const LOG_ENABLED = process.env.REACT_APP_ENABLE_LOG === 'true';

// Definición de la query (asumiendo que existe o para evitar error de referencia)
const GET_PERSONAL_FISCALIA = gql`
  query GetPersonal {
    personal_fiscalia {
      id
      nombre_completo
      cedula
      cargo
      ubicacion
      telefono
      email
      grado
      componente
      tipo_personal
      fecha_nacimiento
    }
  }
`;

const GestionComunicacional = ({ onVolver }) => {
  const [vista, setVista] = useState('dashboard');
  const [refreshing, setRefreshing] = useState(false);
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [busqueda, setBusqueda] = useState('');
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);

  // Intentamos obtener datos reales de Hasura
  const { loading, error, data, refetch } = useQuery(GET_PERSONAL_FISCALIA, {
    errorPolicy: 'all',
  });

  useEffect(() => {
    if (error && LOG_ENABLED) {
      console.log('Info: Usando datos locales (Hasura no disponible)');
    }
  }, [error]);

  const empleados = data?.personal_fiscalia || [];

  const normalizeText = (value) => String(value || '').toLowerCase().trim();

  const empleadosFiltrados = empleados.filter((emp) => {
    if (filtroTipo === 'militar' && emp.tipo_personal !== 'MILITAR') return false;
    if (filtroTipo === 'civil' && emp.tipo_personal !== 'CIVIL') return false;

    const needle = normalizeText(busqueda);
    if (!needle) return true;

    const fields = [
      emp.nombre_completo,
      emp.cedula,
      emp.telefono,
      emp.email,
      emp.cargo,
      emp.ubicacion,
    ];
    return fields.some((field) => normalizeText(field).includes(needle));
  });

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await refetch();
    } catch (err) {}
    setRefreshing(false);
  };

  const getProximosCumpleanos = () => {
    const hoy = new Date();
    const mesActual = hoy.getMonth();
    return empleados.filter(emp => {
      if (!emp.fecha_nacimiento) return false;
      const fecha = new Date(emp.fecha_nacimiento);
      return fecha.getMonth() === mesActual;
    });
  };

  const handleBackGesture = () => {
    if (vista !== 'dashboard') setVista('dashboard');
    else onVolver();
  };

  const renderContent = () => {
    if (loading) return <div className="text-center mt-5"><div className="spinner-border text-primary"></div></div>;
    if (error && empleados.length === 0) {
      return <div className="alert alert-danger">No se pudo cargar el personal desde Hasura.</div>;
    }
    
    if (vista === 'registrar') return <RegistrarEmpleado onAgregarEmpleado={() => { refetch(); setVista('lista'); }} onVolver={() => setVista('lista')} />;
    if (vista === 'editar') return <RegistrarEmpleado empleado={empleadoSeleccionado} onAgregarEmpleado={() => { refetch(); setVista('lista'); }} onVolver={() => setVista('lista')} />;
    if (vista === 'importar') return <ImportarPersonal onVolver={() => setVista('lista')} />;
    if (vista === 'email') return <EnviarComunicado onVolver={() => setVista('dashboard')} />;
    if (vista === 'config-email') return <ConfigSMTP onVolver={() => setVista('configuracion')} showSms={false} title="Configuración Email" />;
    if (vista === 'config-sms') return <ConfigSMTP onVolver={() => setVista('configuracion')} showSmtp={false} title="Configuración SMS" />;
    if (vista === 'reportes') return <ReportesPersonal onVolver={() => setVista('dashboard')} />; // Nueva Vista
    if (vista === 'configuracion') {
      return (
        <div className="container mt-4">
          <button className="btn btn-outline-primary btn-volver mb-3" onClick={() => setVista('dashboard')}>
            <i className="bi bi-arrow-left"></i>
            <span>Volver</span>
          </button>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="mb-0">Configuración</h2>
          </div>
          <div className="row g-4">
            <div className="col-12 col-md-4" onClick={() => setVista('config-email')} style={{ cursor: 'pointer' }}>
              <div className="card h-100 border-0 shadow-sm text-center p-3" style={{ borderRadius: '15px', backgroundColor: '#f1f5ff' }}>
                <div className="mb-2"><i className="bi bi-envelope-at-fill fs-1 text-primary"></i></div>
                <h6 className="fw-bold text-primary mb-0">Config Email</h6>
                <small className="text-muted">SMTP Cliente</small>
              </div>
            </div>
            <div className="col-12 col-md-4" onClick={() => setVista('config-sms')} style={{ cursor: 'pointer' }}>
              <div className="card h-100 border-0 shadow-sm text-center p-3" style={{ borderRadius: '15px', backgroundColor: '#fff7e6' }}>
                <div className="mb-2"><i className="bi bi-chat-left-dots-fill fs-1 text-warning"></i></div>
                <h6 className="fw-bold text-warning mb-0">Config SMS</h6>
                <small className="text-muted">MassivaMovil</small>
              </div>
            </div>
            <div className="col-12 col-md-4" onClick={() => setVista('importar')} style={{ cursor: 'pointer' }}>
              <div className="card h-100 border-0 shadow-sm text-center p-3" style={{ borderRadius: '15px', backgroundColor: '#e6fffa' }}>
                <div className="mb-2"><i className="bi bi-file-earmark-arrow-up-fill fs-1 text-success"></i></div>
                <h6 className="fw-bold text-success mb-0">Importar</h6>
                <small className="text-muted">Excel / CSV</small>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (vista === 'lista') {
      return (
        <div className="bg-light min-vh-100 pb-5">
          {/* Header Superior Móvil/Web - Área de retroceso ampliada */}
          <div className="bg-white border-bottom d-flex justify-content-between align-items-center sticky-top shadow-sm">
            <div 
              className="d-flex align-items-center flex-grow-1 py-3 px-3 pointer" 
              onClick={() => setVista('dashboard')}
              style={{cursor: 'pointer'}}
            >
              <i className="bi bi-chevron-left fs-3 me-2 text-primary"></i>
              <h5 className="mb-0 fw-bold">Directorio de Personal</h5>
            </div>
            <div className="pe-3">
              <button className="btn btn-success btn-sm rounded-pill px-3 shadow-sm py-2" onClick={() => setVista('registrar')}>
                <i className="bi bi-plus-lg me-1"></i>Nuevo
              </button>
            </div>
          </div>

          <div className="container mt-3 px-2">
            <div className="d-flex flex-column flex-md-row gap-2 mb-3">
              <div className="btn-group" role="group" aria-label="Filtro personal">
                <button
                  type="button"
                  className={`btn btn-sm ${filtroTipo === 'todos' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setFiltroTipo('todos')}
                >
                  Todos
                </button>
                <button
                  type="button"
                  className={`btn btn-sm ${filtroTipo === 'militar' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setFiltroTipo('militar')}
                >
                  Militar
                </button>
                <button
                  type="button"
                  className={`btn btn-sm ${filtroTipo === 'civil' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setFiltroTipo('civil')}
                >
                  No Militar
                </button>
              </div>
              <div className="flex-grow-1">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Buscar por nombre, cedula, telefono, correo o ubicacion"
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                />
              </div>
            </div>

            <div className="card border-0 shadow-sm overflow-hidden" style={{borderRadius: '15px'}}>
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="px-3 py-3 small text-muted text-uppercase">Nombre y Cargo</th>
                      <th className="small text-muted text-uppercase">Ubicación</th>
                      <th className="small text-muted text-uppercase text-center">Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {empleadosFiltrados.length > 0 ? empleadosFiltrados.map(emp => (
                      <tr
                        key={emp.id}
                        className="border-bottom"
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          setEmpleadoSeleccionado(emp);
                          setVista('editar');
                        }}
                      >
                        <td className="px-3 py-3">
                          <div className="fw-bold text-dark">{emp.nombre_completo}</div>
                          <div className="text-muted small">{emp.cargo}</div>
                        </td>
                        <td className="small text-muted">{emp.ubicacion}</td>
                        <td className="text-center">
                          <span className={`badge rounded-pill ${emp.tipo_personal === 'MILITAR' ? 'bg-primary bg-opacity-10 text-primary' : 'bg-info bg-opacity-10 text-info'} px-3`}>
                            {emp.tipo_personal}
                          </span>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="3" className="text-center py-5 text-muted">No hay personal registrado</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            
            <div className="mt-4 px-2">
              <button className="btn btn-outline-primary w-100 py-2 rounded-3 border-dashed" onClick={() => setVista('importar')}>
                <i className="bi bi-file-earmark-excel me-2"></i>Importar desde Excel
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-5 border-bottom pb-3">
          <h2 className="text-primary fw-bold">📢 Gestión Comunicacional</h2>
          <button className="btn btn-outline-secondary" onClick={onVolver}>Inicio</button>
        </div>
        <div className="row g-4">
          {/* Directorio */}
          <div className="col-6 col-md-3" onClick={() => setVista('lista')} style={{cursor:'pointer'}}>
            <div className="card h-100 border-0 shadow-sm text-center p-3" style={{borderRadius: '15px', backgroundColor: '#e7f1ff'}}>
              <div className="mb-2"><i className="bi bi-people-fill fs-1 text-primary"></i></div>
              <h6 className="fw-bold text-primary mb-0">Directorio</h6>
              <small className="text-muted">Personal</small>
            </div>
          </div>
          {/* Comunicados */}
          <div className="col-6 col-md-3" onClick={() => setVista('email')} style={{cursor:'pointer'}}>
            <div className="card h-100 border-0 shadow-sm text-center p-3" style={{borderRadius: '15px', backgroundColor: '#e6fffa'}}>
              <div className="mb-2"><i className="bi bi-chat-right-quote-fill fs-1 text-success"></i></div>
              <h6 className="fw-bold text-success mb-0">Comunicados</h6>
              <small className="text-muted">Envíos masivos</small>
            </div>
          </div>
          {/* Reportes */}
          <div className="col-6 col-md-3" onClick={() => setVista('reportes')} style={{cursor:'pointer'}}>
            <div className="card h-100 border-0 shadow-sm text-center p-3" style={{borderRadius: '15px', backgroundColor: '#fff0f3'}}>
              <div className="mb-2"><i className="bi bi-file-earmark-bar-graph-fill fs-1" style={{color: '#ff4d6d'}}></i></div>
              <h6 className="fw-bold mb-0" style={{color: '#ff4d6d'}}>Reportes</h6>
              <small className="text-muted">Cumpleaños</small>
            </div>
          </div>
          {/* Configuración */}
          <div className="col-6 col-md-3" onClick={() => setVista('configuracion')} style={{cursor:'pointer'}}>
            <div className="card h-100 border-0 shadow-sm text-center p-3" style={{borderRadius: '15px', backgroundColor: '#f8f9fa'}}>
              <div className="mb-2"><i className="bi bi-gear-wide-connected fs-1 text-secondary"></i></div>
              <h6 className="fw-bold text-secondary mb-0">Configuración</h6>
              <small className="text-muted">Email / SMS / Importar</small>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <GestureNav onBack={handleBackGesture} onRefresh={handleRefresh}>
      {renderContent()}
    </GestureNav>
  );
};

export default GestionComunicacional;
